import { PayinBank, PayinPaymentMethod, type PayinRequisite } from '~/entities/payin';
import { type PayinPaymentChannel } from '~/entities/payin';
import { type CreateOrderFormValues, type PaymentMethod } from '../model';
import { findMatchingPaymentChannel } from './findMatchingPaymentChannel';

export const buildCreateOrderPayload = (
    values: CreateOrderFormValues,
    paymentChannels: PayinPaymentChannel[],
    paymentMethod: PaymentMethod,
) => {
    const channel = findMatchingPaymentChannel(values, paymentChannels, paymentMethod);
    const { value: amount = 0 } = values.amount;

    const requisites: PayinRequisite = {};

    if (paymentMethod === PayinPaymentMethod.METHOD_SBP) {
        requisites.sbp = {
            phoneNumber: values.requisite.sbp.phoneNumber,
            bank: values.requisite.sbp.bank !== PayinBank.BANK_UNSPECIFIED ? values.requisite.sbp.bank : undefined,
        };
    } else if (paymentMethod === PayinPaymentMethod.METHOD_CARD) {
        requisites.card = {
            holder: values.requisite.card.holder,
            number: values.requisite.card.number,
        };
    }

    return {
        amount: {
            value: amount?.toString(),
        },
        paymentMethod,
        transactionId: undefined,
        currency: channel?.filter?.currency,
        requisites,
        market: undefined,
    };
};
